<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    label-width="120px"
    width="850px"
    @handleConfirm="handleConfirm"
  >
    <template>
      <BjDivider>{{ $t('AddInternalRefundOnlyDoc.Product') }}
        <template #right>
          <el-button type="primary" @click="allWarehouse">{{ $t('allStockInText') }}</el-button>
        </template>
      </BjDivider>
      <el-table :row-class-name="tableRowClassName" :data="form.goodsList" style="width: 100%" border>
        <el-table-column prop="purchaseCode" :label="$t('BusinessPurchaseComponentsPur.code')" align="center" width="127"> </el-table-column>
        <el-table-column prop="skuCode" label="SKU" align="center"> </el-table-column>
        <el-table-column prop="planQty" :label="$t('BusinessPurchaseEntryComPage.planQty')" align="center" width="129"> </el-table-column>
        <el-table-column prop="waitQty" :label="$t('BusinessPurchaseComponentsCom.waitQty')" align="center" width="100"></el-table-column>
        <el-table-column prop="alreadyQty" :label="$t('BusinessPurchaseEntryComPage.alreadyQty')" width="138" align="center">
          <template v-slot="{ row }">
            <BjInputNumber v-model="row.alreadyQty" clearable />
          </template>
        </el-table-column>
        <el-table-column :label="$t('BusinessPurchaseOrderList.dataForm.tolerant')" prop="dataFaultToleranceQty" align="center">
        <template v-slot="{ row }">
            <BjInputNumber v-model="row.dataFaultToleranceQty" min="0" clearable />
          </template>
        </el-table-column>
      </el-table>
    </template>
  </BjDrawerForm>
</template>
<script>
import { purchaseApi} from '@/api';

export default {
  components: {},
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: {
        goodList: [],
      },
    };
  },
  computed: {},
  watch: {
    'form.goodsList': {
      deep: true,
      immediate: false,
      handler: function(newVal, oldVal) {
        for (let i = 0; i < newVal.length; i++) {
          const item = newVal[i];
          const { planQty, alreadyQty } = item;
          const result = planQty - alreadyQty;
          item.waitQty = result < 0 ? 0 : result;
        }
      }
    }
},
  mounted() {},
  methods: {
    tableRowClassName({row}) {
      return Number(row.alreadyQty + row.dataFaultToleranceQty) > Number(row.planQty) ? 'warning-row' : '';
    },
    async show(info) {
      const {data: {id, code}, title} = info;
      const res = await purchaseApi.getStockinsDetail({id, code});
      res.goodsList.forEach(item => {
        item['dataFaultToleranceQty'] = 0;
      });
      this.form = res;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(title);
    },
    // 全部入库
    allWarehouse() {
      this.form.goodsList.forEach(item => {
        item.alreadyQty = item.planQty;
        item.waitQty = 0;
      });
      this.confirmWerahouse();
    },
    handleConfirm() {
      this.confirmWerahouse();
    },
    // 确认入库
    confirmWerahouse() {
      let message = '';
      for (const item of Object.values(this.form.goodsList)) {
        if (!item.alreadyQty) {
          this.msgError(this.$t('BusinessPurchaseComponentsPur.msgError4'));
          return;
        }
        if (item.alreadyQty + item.dataFaultToleranceQty > item.planQty) {
          message += `${item.skuCode} ${this.$t('BusinessPurchaseEntryComPage.planQty')}：${item.planQty}, ${this.$t('BusinessPurchaseComponentsPur.confirmText2')}：${item.alreadyQty}; `;
        }
      }
      if (message.length > 0) {
        this.$confirm(message, this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(() => this.sendApi(this.form)).catch(() => {});
      } else {
        this.sendApi(this.form);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
    sendApi(API_DATA) {
      console.log(API_DATA);
      this.$MessageBox({ content: this.$t('BusinessPurchaseEntryComPage.msgBox4') }).then(() => {
        purchaseApi.generateStockins(API_DATA).then(res => {
          if (!res.failed) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
              this.$refs.BjDrawerForm.hide();
            }, 500);
          }
        });
      }).catch(() => {});
    },
  }
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
::v-deep .el-table .warning-row{
  color: red!important;
}
</style>
